"use strict";

export default {
  offen: "fb0ddfd4-a23d-45c7-917f-77d199846e4a",
  abgeschlossen: "de9f92f2-9015-476c-b0b0-f84e7a3d072d"
};
